export const LicitacaoDetalheTabsTitles = {
  EDITAL_DOCUMENTOS: 'Edital/Documentos',
  IMPUGNACAO_RECURSOS: 'Impugnações/Recursos',
  PUBLICACOES: 'Publicações',
  COTACOES: 'Cotações',
  PROPOSTAS: 'Propostas',
  CERTIDOES: 'Certidões',
  ATAS: 'Atas',
  PARECERES: 'Pareceres',
  ADJUDICACOES: 'Adjudicações',
  HOMOLOGACOES: 'Homologações',
  MIDIAS: 'Mídias',
  CONTRATOS: 'Contratos',
  EMPENHOS: 'Empenhos',
  PARTICIPANTES: 'Participantes'
};
